import { useCallback } from 'react';
import { trackEvent, trackPageView } from '../utils/mixpanel';

export const useMixpanel = () => {
    const track = useCallback((eventName, properties) => {
        trackEvent(eventName, properties);
    }, []);

    const trackPage = useCallback((pageName) => {
        trackPageView(pageName);
    }, []);

    return { track, trackPage };
};